// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "request__main-zGiCb";
var _4 = "comment-35P0J";
var _5 = "chip-1fwkA";
var _6 = "comment__header-gSVNv";
var _7 = "comment__text-2m9pQ";
export { _1 as "__esModule", _2 as "tablet", _3 as "request__main", _4 as "comment", _5 as "chip", _6 as "comment__header", _7 as "comment__text" }
export default { "__esModule": _1, "tablet": _2, "request__main": _3, "comment": _4, "chip": _5, "comment__header": _6, "comment__text": _7 }
